import React from "react";
import "../style/WhiskeyCard.css";

const WhiskeyCard = ({ whiskey, caskClicked, user }) => {
  return (
    <div className="whiskeyCard">
      <div className="headerContainer">
        <h5>{whiskeyCardTitle(whiskey)}</h5>
      </div>
      <div className="regionCountryContainer">
        <p>
          {whiskey?.region} {whiskey.country}
        </p>
      </div>
      <div className="distilleryContainer">
        {whiskey?.distillery
          ? whiskey?.distillery.map((distillery, i) => {
              if (i < whiskey?.distillery.length - 1) {
                return <p key={i}>{distillery},</p>;
              } else {
                return <p key={i}>{distillery}</p>;
              }
            })
          : ""}
      </div>
      <div className="caskContainer">
        {whiskey?.cask ? (
          <p>
            {whiskey?.cask?.map((cask, i) => {
              return (
                <React.Fragment key={i}>
                  {i > 0 ? "/" : ""}
                  <button className="cask" value={cask} onClick={caskClicked}>
                    {cask}
                  </button>
                </React.Fragment>
              );
            })}
          </p>
        ) : (
          <p></p>
        )}
      </div>
      <div className="alcContainer">
        {whiskey?.alc ? <p>{whiskey?.alc} &#8240;</p> : <p></p>}
      </div>
      <div className="priceContainer">
        <p>{whiskey?.price} €</p>
      </div>
    </div>
  );
};

// Filters and modifies distillery and whiskeyTitle to create the whiskeyCardTitle; based on customer's wish
let whiskeyCardTitle = (whiskey) => {
  if (whiskey?.distillery[0] === "Irish Distillers") return;
  if (whiskey?.distillery[0] === "Isle of Arran Distillers")
    return `Arran ${whiskey.whiskeyTitle}`;
  return `${(whiskey?.distillery[0] ?? "")
    .split(" ")
    .filter((word) => word !== "Distillery" && word !== "The")
    .join(" ")} ${whiskey.whiskeyTitle} `;
};

export default WhiskeyCard;
